export const PALETTE = {
  BLUE: ["#447bee", "#698aee", "#869aee", "#9eaaee", "#b4bbee"],
  PURPLE: ["#53339e", "#5d3ba3", "#6a48b0", "#7553b6", "#936dcf", "#9876cc", "#b795e6", "#d7b8ff"],
  AQUA: ["#177470", "#2a827d", "#3a908b", "#489e99", "#57aca7"],
  RED: ["#ee2a63", "#f15676", "#f3768a", "#f3929e", "#f1acb3"],
  ORANGE: ["#FFA10A", "#FFB947", "#FFD085"],
  GREEN: ["#0f8a19", "#209e2a", "#41ba4b", "#5dc966", "#79d480"],
  CLEAR_BLUE: ["#00C6E8", "#009EBF", "#007797", "#005371", "#00304D"],
};
